/* eslint-disable no-unused-vars */
export enum SecurityTypeCode {
  CDO = "CDO",
  CP = "CP",
  TD = "TD",
  REPO = "REPO",
  FXS = "FXS",
  LTD = "LTD",
  FXO = "FXO",
  CORP = "CORP",
  XBS = "XBS",
  FUTBND = "FUT BND",
  CALL = "CALL",
  BILL = "BILL",
  FUTBILL = "FUT BILL",
  OPTFUTBND = "OPT FUT BND",
  IRS = "IRS",
  MBS = "MBS",
  FUTIRF = "FUT IRF",
  OIS = "OIS",
  CMO = "CMO",
  GOVT = "GOVT",
  SWO = "SWO",
  IBS = "IBS",
  FRA = "FRA",
  ElevenAM = "11AM",
  CDSO = "CDSO",
  COLL = "COLL",
  VAR = "VAR",
  CDX = "None",
  FXF = "FXF",
  EXO = "EXO",
  OPTFUTIRF = "OPT FUT IRF",
  FRD = "FRD",
  CDS = "CDS",
  SYN = "SYN",
  SUPRA = "SUPRA",
  CFL = "CFL",
  ZCS = "ZCS",
  OBS = "OBS",
  XCS = "XCS",
  BNDO = "BNDO",
  VOL = "VOL",
  PNOTE = "PNOTE",
  ABS = "ABS",
  SELLBUY = "SELLBUY",
  CD = "CD",
  SEMI = "SEMI",
  NCD = "NCD",
  OPTFUTBILL = "OPT FUT BILL",
}
